import { Dictionary } from "../../../../types";

export class FieldTree implements Iterator<object>
{
    repeat!: Iterator<number> | null;
    nullable!: Iterator<boolean> | null;
    iterators: Dictionary<string, Iterator<object>> = {};
    constructor(obj: object)
    {
        for (const [key, val] of Object.entries(obj))
        {
            if (key === "$nullable")
            {
                this.nullable = expandNullableCount(val)[Symbol.iterator]();
            }
            else if (key === "$repeat")
            {
                this.repeat = val[Symbol.iterator]();
            }
            else if (Array.isArray(val))
            {
                this.iterators[key] = val[Symbol.iterator]();
            }
            else
            {
                this.iterators[key] = new FieldTree(val);
            }
        }
    }

    private nextObj()
    {
        // Instead of keeping nullable values strictly columnar we mix nullability for the object itself and iterable entries
        if (this.nullable?.next().value === true)
        {
            return null;
        }
        const result = Object.create(null);
        for (const [key, val] of Object.entries(this.iterators))
        {
            result[key] = this.nullable?.next().value === true
                ? null
                : val!.next().value;
        }
        return result;
    }

    next(): { value: void; done: true; } | { value: object; done?: false | undefined; }
    {
        if (this.repeat)
        {
            const result = [];
            const count = this.repeat.next().value;
            for (let i = 0; i < count; i += 1)
            {
                result.push(this.nextObj());
            }
            return { value: result };
        }
        else
        {
            return { value: this.nextObj() };
        }
    }
}

// Nullable fields use RLE encoding - count of successive non-null fields, then null fields, then non-null, etc.
// See NestedVueDataResult.NullableCounter
function expandNullableCount(nullableCounts: number[])
{
    return nullableCounts.flatMap((x, i) => new Array(x).fill(i % 2 == 0));
}
